var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_968_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0249 8.33314L10.7999 4.2998C10.5583 3.50814 9.44159 3.50814 9.20826 4.2998L7.97492 8.33314H4.26659C3.45826 8.33314 3.12492 9.3748 3.78326 9.84147L6.81659 12.0081L5.62492 15.8498C5.38326 16.6248 6.28326 17.2498 6.92493 16.7581L9.99993 14.4248L13.0749 16.7665C13.7166 17.2581 14.6166 16.6331 14.3749 15.8581L13.1833 12.0165L16.2166 9.8498C16.8749 9.3748 16.5416 8.34147 15.7333 8.34147H12.0249V8.33314Z",
    fill: "#FF8400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_2369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRate);
export default __webpack_public_path__ + "static/media/star_rate.879a2fbc2179e3496bc071537c05e1d6.svg";
export { ForwardRef as ReactComponent };